<template>
    <div id="app">
        <router-view
            :list-of-pitchers="listOfPitchers"
            :list-of-games="listOfGames"
            :list-of-teams="listOfTeams"
            :global-user-account="globalUserAccount"
            @compelete-local-storage="completeLocalStorage"
        />
        <ToolTips
            v-if="!!toolTip"
            :list-of-teams="listOfTeams"
        />
        <div v-if="bone3DPlayerURL">
            <div
                class="bone3d-dashboard"
                v-if="modal3d.display">
                <div id="global-navi-view" v-if="!modal3d.fullscreen">
                    <div class="closeModal"
                         @click="closeBone3d()"
                    >
                        <p> ← </p>
                    </div>
                    <div id="globalNaviWrapper">
                        <div id="globalNaviLogo">
                            <div @click="closeBone3d('top')">
                                BACS
                            </div>
                        </div>
                    </div>
                </div>
                <iframe
                    ref="bone3dplayer"
                    :class="{ 'fullscreen' : modal3d.fullscreen }"
                    :src="bone3DPlayerURL"></iframe>
            </div>

        </div>
        <div v-if="!bone3DPlayerURL">
            <video-modal-wrapper :list-of-teams="listOfTeams" />
            <div
                v-if="modal3d.display"
                class="modal3d"
            >
                <three
                    :vs-data-clicked-ball="modal3d"
                    :init-mode="modal3d.mode"
                    @modal3d-off="modal3d.display=false"
                />
            </div>
        </div>

        <!-- メッセージモーダル -->
        <message-modal
            v-show="messageModalShow"
            :message="message"
            @message-modal-off="messageModalOff"
        />
    </div>
</template>

<script>
import '@/reset.css'
import '@/default.css'
import '@/default_sp.css'
import '@/iconFont.css'
import '@/iconImgSp.css'
import ToolTips from "@/components/utility/ToolTips.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import common from "@/common"
import Three from "@/components/3d.vue"
import MessageModal from "@/components/MessageModal.vue"
import setting from "@/setting"
import ls from "@/ls"
import GlobalNaviView from "@/components/GlobalNaviView.vue"

export default {
    name: 'App',
    components: {
        GlobalNaviView,
        MessageModal,
        Three,
        ToolTips,
        VideoModalWrapper: () => import("./components/VideoModalWrapper.vue")
    },
    data() {
        let listOfPitchers = this.$ls.get('listOfMyTeamPitchers', {})
        let listOfGames = this.$ls.get('listOfMyTeamGames', [])
        let listOfTeams = this.$ls.get('listOfTeams', {})
        let globalUserAccount = this.$ls.get('userAccount', {})
        let currentPitchingNum = this.$ls.get('currentPitchingNum', 0)

        let bone3DPlayerURL = setting.bone3dPlayerURL

        return {
            listOfPitchers,
            listOfGames,
            listOfTeams,
            globalUserAccount,
            pitchingActiveTab: 0,
            currentPitchingNum,
            modal3d: {
                display: false,
                ballId: '',
                allData: {},
                mode: 'atBat',
                fullscreen : false, // 骨格3Dの全画面モードで使用
            },
            message: '',
            messageModalShow: false,
            bone3DPlayerURL,
            iframeReady : false,
        }
    },
    watch : {
        'modal3d.display' : function(val,oldVal) {
            if(val) {
                // console.warn("modal3d ....",val,this.modal3d)
                if(this.bone3DPlayerURL) {
                    this.$nextTick(() => {
                        this.showBone3DPlayer()
                    })
                }

                this.$$router.replace({
                    query: {
                        'three': 1,
                        'ballId' : this.modal3d.ballId,
                    }
                })
            }
            else{
                if(this.bone3DPlayerURL){
                    window.removeEventListener('message', this.handleMessage)
                }

                this.$$router.replace({
                    query: {
                        'three' : undefined,
                        'ballId' : undefined,
                    }
                })
            }
        }
    },
    computed: {
        ...mapGetters(['toolTip','listOfStadiums'])
    },
    mounted() {
        this.completeLocalStorage()
    },
    created() {
        this.$router.afterEach(() => {
            this.messageModalOff()
            this.$store.commit('setToolTip',null)
        })
        let globalPitcherData = this.$ls.get('globalPitcherData', null)
        if (globalPitcherData) {
            this.$store.commit('setGlobalPitcherData', globalPitcherData)
        }

        let globalComparisonPitcherData = this.$ls.get('globalComparisonPitcherData', null)
        if (globalComparisonPitcherData) {
            this.$store.commit('setGlobalComparisonPitcherData', globalComparisonPitcherData)
        }

        // 基準投手
        this.$root.$on('setPitcherData', (globalPitcherData) => {
            this.$store.commit('setGlobalPitcherData', globalPitcherData)
        })
        this.$root.$on('setComparisonPitcherData', (globalComparisonPitcherData) => {
            this.$store.commit('setGlobalComparisonPitcherData', globalComparisonPitcherData)
        })
        this.$root.$on('remove-comparison-pitcher-data', () => {
            this.$store.commit('setGlobalComparisonPitcherData', null)
        })
        // 神事先生コンパネ用基準投手
        this.$root.$on('setPitcherDataJinji', (globalPitcherDataJinji) => {
            this.globalPitcherDataJinji = globalPitcherDataJinji
        })
        // 神事先生コンパネ用比較投手
        this.$root.$on('setComparisonPitcherDataJinji', (globalComparisonPitcherDataJinji) => {
            this.globalComparisonPitcherDataJinji = globalComparisonPitcherDataJinji
        })
        this.$root.$on('remove-comparison-pitcher-data-jinji', () => {
            this.globalComparisonPitcherDataJinji = null
        })
        this.$root.$on('modal3dOn', this.modal3dOn)

        this.$root.$on('messageModalOn', this.messageModalOn)
        this.$root.$on('messageModalOff', this.messageModalOff)
        this.$root.$on('completeLocalStorage', this.completeLocalStorage)

        // デバイス判定
        if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
            document.body.classList.add('platform-ipad')
        } else {
            document.body.classList.add('platform-pc')
        }
        if (window.navigator.standalone) {
            document.body.classList.add('standalone')
        } else {
            if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
                if (window.innerHeight === 704) {
                    document.body.classList.remove('tab672')
                    document.body.classList.add('tab704')
                } else if (window.innerHeight === 672) {
                    document.body.classList.remove('tab704')
                    document.body.classList.add('tab672')
                }
            }
            window.addEventListener('resize',  this.resize, false)
        }
    },
    methods: {
        messageModalOn (message, time = 2000) {
            this.message = message
            this.messageModalShow = true
            setTimeout(this.messageModalOff, time)
            //console.log('messageModalOn', message, time)
        },
        messageModalOff () {
            this.messageModalShow = false
        },
        modal3dOn (id, allData, mode) {
            console.log('modal3dOn', id, allData)
            let selectedBallInning = allData.inning.toString()
            let selectedBallPaofinning = allData.paofinning.toString()
            const batter = allData.Batter ? allData.Batter.identifier + '@' + allData.Batter.team_id : allData.pitchingdata.BatterId + '@' + allData.pitchingdata.BatterTeam

            const query = {
                batter: batter,
                game_id: allData.game_id,
                he_first: true
            }
            API.PITCHES.getIndex(query,
                (json) => {
                    const array = json.filter(d=>d.inning === selectedBallInning && d.paofinning === selectedBallPaofinning).map((d,i)=>{
                        if (d.pitchingdata) {
                            if (d.pitchingdata.TaggedPitchType === 'FourSeamFastball') {
                                d.pitchingdata.TaggedPitchType = 'Fastball'
                            }
                            if (d.pitchingdata.TaggedPitchType === 'OneSeamFastball') {
                                d.pitchingdata.TaggedPitchType = 'TwoSeamFastball'
                            }
                            if (['FoulBallNotFieldable','FoulBallFieldable'].includes(d.pitchingdata.PitchCall)) {
                                d.pitchingdata.PitchCall = 'FoulBall'
                            }
                        }
                        d.pitchno = i + 1
                        d.pitchofpa = Number(d.pitchofpa)
                        return d
                    }).sortBy('pitchofpa')
                    this.modal3d = {
                        display: true,
                        ballId: id,
                        allData: this.$copy(allData),
                        atBatDataList: array,
                        mode: mode
                    }
                },
                (json) => {
                    console.log('getAllPitchesAPI取得失敗', json)
                    common.LOG('ERROR', '打撃データ詳細', 'getAllPitches', JSON.stringify(json))
                })
        },
        completeLocalStorage () {
            let listOfPitchers = this.$ls.get('listOfMyTeamPitchers')
            if (listOfPitchers !== null) {
                this.listOfPitchers = listOfPitchers
            }
            let listOfGames = this.$ls.get('listOfMyTeamGames')
            if (listOfGames !== null) {
                this.listOfGames = listOfGames
            }
            let listOfTeams = this.$ls.get('listOfTeams')
            if (listOfTeams !== null) {
                this.listOfTeams = listOfTeams
                this.$store.commit('setTeamsList', listOfTeams)
            }
            let listOfStadiums = this.$ls.get('listOfStadiums', {})
            if (listOfStadiums !== null) {
                this.$store.commit('setStadiums', listOfStadiums)
            }
            let globalUserAccount = this.$ls.get('userAccount')
            if (globalUserAccount !== null) {
                this.globalUserAccount = globalUserAccount
                this.$store.commit('setUserAccount', globalUserAccount)
            }
        },
        resize () {
            if (/ipad/i.test(window.navigator.userAgent) || /mac/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0) {
                if (window.innerHeight === 704) {
                    document.body.classList.remove('tab672')
                    document.body.classList.add('tab704')
                } else if (window.innerHeight === 672) {
                    document.body.classList.remove('tab704')
                    document.body.classList.add('tab672')
                }
            }
        },

        handleMessage(event) {
            const data = event.data
            const that = this

            const origin = this.iframeOrigin(this.bone3DPlayerURL)

            if(data.module === 'bacs') {
                const name = data.name
                if(name === 'ready'){

                    this.iframeReady = true
                    //  準備完了
                    const iframeWindow = this.$refs.bone3dplayer.contentWindow
                    if(iframeWindow) {

                        //  選択済にボールをクリアする
                        iframeWindow.postMessage({
                            module: 'bacs',
                            name: 'clearPitchList',
                            value: null,
                        }, origin)

                        this.modal3d.atBatDataList.forEach((item) => {
                            //  ボールを追加するメッセージを送信する
                            const iframeWindow = this.$refs.bone3dplayer.contentWindow
                            if (iframeWindow) {
                                iframeWindow.postMessage({
                                    module: 'bacs',
                                    name: 'addPitchId',
                                    value: item.id,
                                }, origin)
                            }
                        })
                        //  選択されたボールを指定する
                        iframeWindow.postMessage({
                            module: 'bacs',
                            name: 'pitchId',
                            value: this.modal3d.ballId,
                        }, origin)
                    }

                }
                else if(name === 'fullscreen'){
                    // 全画面表示の場合
                    //  that.modal3d.fullscreen = data.body.value
                    //  変更を検知できないようなので、書き方を変える
                    that.$set(that.modal3d, 'fullscreen', data.body.value)
                }
                else if(name === 'reload-url'){
                    // iframe側のtokenが切れているので、画面前提をリロードする
                    window.location.reload()
                }
            }
        },

        showBone3DPlayer(){
            window.addEventListener('message', this.handleMessage)

            const account = ls.get('userAccount')
            const accountJson = JSON.stringify(account)
            const origin = this.iframeOrigin()

            // iframe側に必要な情報を渡す
            this.$refs.bone3dplayer.onload = () => {
                setTimeout(() => {
                    const iframeWindow = this.$refs.bone3dplayer.contentWindow
                    if (iframeWindow) {
                        iframeWindow.postMessage({
                            module: 'bacs',
                            name: 'init',
                            api : setting.apiURL,
                            account : JSON.parse(accountJson),
                            parentOrigin: window.location.origin // 例: "http://localhost:8080"
                        }, origin)

                        if(!this.iframeReady){
                            //  まだ、初期化されていないなら、再度メッセージを送る
                            setTimeout(() => {
                                iframeWindow.postMessage({
                                    module: 'bacs',
                                    name: 'init',
                                    api : setting.apiURL,
                                    account : JSON.parse(accountJson),
                                    parentOrigin: window.location.origin // 例: "http://localhost:8080"
                                }, origin)
                            },1000)
                        }
                    }
                },100)
            }
        },
        iframeOrigin() {
            try {
                const url = new URL(this.bone3DPlayerURL)
                return url.origin
            } catch (e) {
                return "*"
            }
        },
        closeBone3d(name = null){
            if(name){
                const p = this.$router.push({
                    name : name
                }).then(() => {
                    this.modal3d.display = false
                })
                console.warn("p is",p)
            }
            else {
                this.modal3d.display = false
            }
        }
    },
    destroy () {
        window.removeEventListener('resize',  this.resize, false)
        this.$root.$off('setPitcherData', (globalPitcherData) => {
            this.globalPitcherData = globalPitcherData
        })
        this.$root.$off('setComparisonPitcherData', (globalComparisonPitcherData) => {
            this.globalComparisonPitcherData = globalComparisonPitcherData
        })
        this.$root.$off('remove-comparison-pitcher-data', () => {
            this.globalComparisonPitcherData = null
        })
        // 神事先生コンパネ用基準投手
        this.$root.$off('setPitcherDataJinji', (globalPitcherDataJinji) => {
            this.globalPitcherDataJinji = globalPitcherDataJinji
        })
        // 神事先生コンパネ用比較投手
        this.$root.$off('setComparisonPitcherDataJinji', (globalComparisonPitcherDataJinji) => {
            this.globalComparisonPitcherDataJinji = globalComparisonPitcherDataJinji
        })
        this.$root.$off('remove-comparison-pitcher-data-jinji', () => {
            this.globalComparisonPitcherDataJinji = null
        })
        this.$root.$off('modal3dOn', this.modal3dOn)
        this.$root.$off('messageModalOn', this.messageModalOn)
        this.$root.$off('messageModalOff', this.messageModalOff)
    }
}
</script>
